<div class="breadcrumb-area">
    <h1>Procesos Productivos</h1>
    <span class="ml-1" (click)="creating = true">
        <i style="font-size: 0.8em" class="a-hover fa fa-plus">
            <span style="font-family: 'Nunito', sans-serif">
                CREAR PROCESO PRODUCTIVO
            </span>
        </i>
    </span>
</div>
<div class="card mb-5">
    <div class="card-header">
        <h3>Lista Procesos Productivos</h3>
    </div>
    <div class="card-body">
        <div class="input-group input-group-sm mb-3">
			<label for="filterRecipe" class="input-group-text">Filtra</label>
			<input type="text" (input)="filter()" [(ngModel)]="filterWord" name="filterRecipe"
				placeholder="Ingresa el código o el nombre de la receta" id="filterRecipe" class="form-control">
		</div>
        <div class="row">
			<div class="col-sm" *ngIf="!loading">
				<div class="table table-responsive">
					<table class="table">
						<caption *ngIf="filterWord">Se muestran los resultados para {{filterWord}}</caption>
						<thead>
							<tr>
								<th>
									Nombre
								</th>
								<th class="ta">
									Productos de Entrada
								</th>
								<th>
									Productos de Salida
								</th>
                                <th>Mostrar/Ocultar</th>
								<th class="ta">
									Acciones
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let item of filterProcess; let i = index">
								<tr>
									<td  class="ta font-bold">
										{{item.process.name}}
									</td>
									<td  class="ta">
                                        {{getQuantityProductIn(item.products)}}
									</td>
                                    <td  class="ta">
										{{getQuantityProductOut(item.products)}}
									</td>
									<td class="ta">
										<span (click)="showDetials(item.process)" class="cursor-pointer">
											<i class="fa" [ngClass]="showItem==item.process.id?'fa-chevron-up':'fa-chevron-down'"></i> {{showItem==item.process.id?'Ocultar ':'Mostrar '}}
										</span>
									</td>
                                    <td></td>
								</tr>
								<tr *ngIf="showItem!=null && showItem==item.process.id" class="px-2">
                                    <td colspan="5" class="border bg-th">
                                        <div class="row">
                                            <app-edit-production-process [processId]="item.process.id"/>
                                        </div>
                                    </td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
				<span *ngIf="filterProcess.length==0">
					<i class="fa fa-circle-info"></i>
					{{filterWord?'No existen Recetas para el filtro '+filterWord:'Aún no se han ingresado Recetas'}}
				</span>
			</div>
            <div class="col-sm" *ngIf="loading">
                <app-loading-animation [height]="'3rem'"/>
            </div>
		</div>
    </div>
</div>

<app-create-production-process *ngIf="creating" [showModal]="creating" (closed)="closeModalCreate($event)"></app-create-production-process>